import { adminHttpClient } from '../../commons/adminHttpClient'
import { AddDefaultExpenseTypeRequest } from './addDefaultExpenseType'

export type EditDefaultExpenseTypeRequest = AddDefaultExpenseTypeRequest & {
  expenseTypeId: number
  previousExpenseCategoryId: number
  previousProductId: number
}

const editDefaultExpenseType = (request: EditDefaultExpenseTypeRequest): Promise<void> =>
  adminHttpClient.put('Expenses/DefaultExpenseTypes', request)

export default editDefaultExpenseType
